import { useCallback, useEffect, useState } from "react";
import PropTypes from "prop-types";
import useBrandContext from "Contexts/brand-context";
import useCustomerContext from "Contexts/customer-context";
import Page from "Shared/components/page/page";
import Description from "Shared/components/description";
import Button from "Shared/components/button";
import { fetchEncryptedUserData } from "Shared/util/web-api";
import makeComponentTrashable from "trashable-react";
import { useTranslation } from "Shared/util/custom-hooks";
import styles from "./business-loans-page.css";

const getImageUrl = (brandName) => {
    if (brandName === "EuroFinans") return "/euro-finans/business-loans.png";
    if (brandName === "PrioritetFinans")
        return "/prioritet-finans/business-loans.png";
    if (brandName === "FinanceLink") return "/finance-link/business-loans.png";
    return null;
};

const BusinessLoansPage = ({ registerPromise }) => {
    const [url, setUrl] = useState("");
    const [userData, setUserData] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const { brandData, loadingBrandData } = useBrandContext();
    const { customerData, loadingCustomerData } = useCustomerContext();
    const t = useTranslation((x) => x.businessLoansPage);

    const openBusinessLoans = useCallback(() => {
        window.open(url, "_blank");
    }, [brandData.businessLoansUrl, url, userData]);

    useEffect(() => {
        setUrl(brandData.businessLoansUrl);
        if (brandData.name !== "PrioritetFinans") return;
        setIsLoading(true);
        registerPromise(fetchEncryptedUserData()).then((result) => {
            setIsLoading(false);
            setUserData(result);
            setUrl(
                `${brandData.businessLoansUrl}?data=${encodeURIComponent(
                    result,
                )}`,
            );
        });
    }, [brandData, customerData]);

    const readableBrandName =
        !loadingBrandData && brandData.name.replace(/([A-Z])/g, " $1").trim();

    return (
        <Page
            title={t.weHelpYouWithBusinessLoans}
            narrowWidth
            loading={isLoading || loadingBrandData || loadingCustomerData}
        >
            <div className={styles.container}>
                <div className={styles.imageContainer}>
                    <img
                        src={getImageUrl(brandData.name)}
                        alt="business_loans"
                    />
                </div>
                <div className={styles.infoContainer}>
                    <Description
                        text={t.format(t.withOurBusinessLoanText, {
                            brandName: readableBrandName,
                        })}
                    />
                    <Description text={t.applyByClicking} />
                    <div className={styles.buttonContainer}>
                        <Button
                            buttonType="action-primary"
                            text={t.applyNow}
                            onClick={openBusinessLoans}
                        />
                    </div>
                </div>
            </div>
        </Page>
    );
};

BusinessLoansPage.propTypes = {
    registerPromise: PropTypes.func.isRequired,
};

export default makeComponentTrashable(BusinessLoansPage);
